var Menu = require('models/menu');
var MenuView = require('views/menu/menu-view');
var Controller = require('controllers/base/controller');

var ContentService = require('services/content-service');
var CourseSettingsService = require('services/course-settings-service');
var MenuService = require('services/menu-service');
var SessionService = require('services/session-service');

var MenuController = Controller.extend({
  show: function(params, route, options){
    SessionService.set('queryParams', options.query);

    var defaults =  {
      homePage: 'home',
      type: 'module', //module menu
      groups: false // forces order at the group level.
    };
    var menuSettings = CourseSettingsService.get('menu');
    _.defaults(menuSettings, defaults);

    if (options.query.group){
      MenuService.currentGroup = EF.groups.find({ id: parseInt(options.query.group) });
    } else {
      MenuService.currentGroup = null;
    }

    var page = params.page || menuSettings.homePage;

    if(CourseSettingsService.get('menuOverride') && page == menuSettings.homePage){
      let menuOverride = CourseSettingsService.get('menuOverride');
      if (menuOverride && menuOverride.postMessage){
        window.parent.postMessage({ event_type: menuOverride.postMessage }, '*');
      }else {
        window.location = menuOverride;
      }
      return;
    }

    var menu = new Menu(menuSettings);
    menu.set('key', page);

    ContentService.applyContentAndLocale(menu, 'menu.' + page).then((container) => {
      if(menu.get('groups') && !EF.enrollment.get('demoMode')) {
        EF.groups.lockGroups(menu.get('lockPastGroups'), MenuService.getUnlockDay());
      }
      MenuService.autoPlay();

      this.view = new MenuView({
        className: 'menu ' + page,
        model: menu,
        region: 'main'
      });
    });
  }
});

module.exports = MenuController;
